const CookieKeys = {
  ACCESS_TOKEN: 'studentAccessToken',
}

export default CookieKeys
